import { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { noop } from '@tanstack/react-query'
import { trpc } from '@/main'
import { EmailGallery } from './-components/admin/email-gallery'
import { SuperAdminBoundary } from './-components/admin/super-admin-boundary'
import { EmailGallerySkeleton, EmailsNote, EmailsPending } from './-components/admin/admin-pending'
import { InfoIcon } from './-components/settings/settings-icons'
import { SETTINGS_STACK } from './-components/settings/settings-section'

// The rendered templates are this page's alone; the layout's tree reads the render-free index (admin.tsx).
export const Route = createFileRoute('/_app/admin/emails')({
  context: () => ({ emailGalleryQueryOptions: trpc.admin.renderEmailTemplates.queryOptions() }),
  loader: ({ context }) => {
    context.queryClient.query(context.emailGalleryQueryOptions).catch(noop)
  },
  component: RouteComponent,
  pendingComponent: EmailsPending,
})

function RouteComponent() {
  return (
    <div className={SETTINGS_STACK}>
      <EmailsNote icon={<InfoIcon className="size-4 shrink-0" />} />
      <SuperAdminBoundary what="the email templates">
        <Suspense fallback={<EmailGallerySkeleton />}>
          <EmailGallery />
        </Suspense>
      </SuperAdminBoundary>
    </div>
  )
}
